// Brand Infringement alerts are switched off for now: the bell hides their tab
// and cards. The api's daily sweep is off too (ALERTS_ENABLED in
// services/job/brand_infringement.py). Flip both to bring them back.
export const BRAND_INFRINGEMENT_NOTIFICATIONS_ENABLED = false;
